import { Language, Subsidiary } from '@coolblue-development/constants';
import { formatCurrency } from '@coolblue-development/next-formatting-utils/core';

/**
 * For the filter page we show the price without the currency symbol and always
 * formatted for the Dutch locale.
 */
function formatCurrencyForCoolblue(amount: number): string {
  return formatCurrency({
    amount,
    language: Language.DUTCH,
    subsidiary: Subsidiary.NL,
    options: { hideCurrencySymbol: true }
  });
}

export function getPriceValue(value: string, separator: string): string {
  if (value === '') {
    return '';
  }
  const [minValue, maxValue] = value.split('-');
  if (minValue === '0') {
    return `${separator} ${formatCurrencyForCoolblue(Number(maxValue))}`;
  }
  return `${formatCurrencyForCoolblue(Number(minValue))} ${separator} ${formatCurrencyForCoolblue(Number(maxValue))}`;
}
